import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private observableErrors = new BehaviorSubject<MessageObject>(null);
  public errors = this.observableErrors.asObservable();

  private observableMessages = new BehaviorSubject<MessageObject>(null);
  public messages = this.observableMessages.asObservable();

  constructor() { }

  showSuccess(detail: string, header?: string): void {
    const mo = new MessageObject();

    // Standard Header
    mo.header = 'Es ist ein Fehler aufgetreten';
    if (header) {
      mo.header = header;
    }

    mo.message = detail;
    mo.icon = 'success';

    this.observableMessages.next(mo);
  }

  showError(detail: string, header?: string): void {
    const mo = new MessageObject();

    // Standard Header
    mo.header = 'Es ist ein Fehler aufgetreten';
    if (header) {
      mo.header = header;
    }

    mo.message = detail;
    mo.icon = 'error';

    this.observableErrors.next(mo);
  }

  clear() {
    this.observableErrors.next({} as MessageObject);
    this.observableMessages.next({} as MessageObject);
  }
}

export class MessageObject
{
  public header: string;
  public message: string;
  public icon: string;
}
